// Acceso (cómo entran las personas), almacenamiento, generador de PDF y el CRM de Carlos (apagado). Solo lectura: se
// cambia en el .env del servidor. Los pasos que tiene que hacer Diego salen de ARQUITECTURA.md §10.
import { VARIANTES } from '@cotizador/compartido';
import { usarUsuario } from '../../sesion.tsx';
import { Chip, Seccion } from '../../componentes/ui.tsx';
import { plural } from '../../logica/etiquetas.ts';

const PROVEEDOR = {
  local: 'Modo desarrollo: el enlace se enseña en pantalla (solo en esta Mac).',
  firebase: 'Firebase: el enlace llega al correo. Plan gratis: 5 correos al día.',
  smtp: 'Correo de solarix.mx (Microsoft 365): el servidor manda el enlace.',
} as const;

export function Acceso() {
  const { config, politica } = usarUsuario();
  const variantes = config.pdf.variantes;
  return (
    <div className="pila pila--grande">
      <Seccion titulo="Acceso" descripcion="Enlace al correo, sin contraseñas. La sesión dura 30 días.">
        <div className="hoja pila">
          <p className="estado-ia">
            <Chip tono={config.acceso.modo_desarrollo ? 'rojo' : 'verde'}>{config.acceso.proveedor}</Chip>
            <span>{PROVEEDOR[config.acceso.proveedor]}</span>
          </p>
          {config.acceso.modo_desarrollo && (
            <ol className="lista-simple lista-simple--numerada">
              <li>Para usar Firebase: en la consola de Firebase, Authentication → Sign-in method, activa “Correo/contraseña” y “Vínculo de correo electrónico”.</li>
              <li>Agrega cotizador.solarix.mx a Dominios autorizados.</li>
              <li>Pon en .env ACCESO_PROVEEDOR=firebase y FIREBASE_WEB_API_KEY (la apiKey de la app web; no es secreta).</li>
              <li>O bien SMTP con un buzón de solarix.mx: ACCESO_PROVEEDOR=smtp y los datos SMTP_*.</li>
            </ol>
          )}
        </div>
      </Seccion>
      <Seccion titulo="Vendedores externos" descripcion="Si un vendedor externo puede editar las cotizaciones de otros. Ver, todos ven todo.">
        <div className="hoja pila">
          <p className="estado-ia">
            <Chip tono={politica.externo_edita_solo_lo_suyo ? 'prusia' : 'neutro'}>{politica.externo_edita_solo_lo_suyo ? 'Solo lo suyo' : 'Editan todo'}</Chip>
            <span>
              {politica.externo_edita_solo_lo_suyo
                ? 'Un vendedor externo solo edita las cotizaciones que son suyas y solo crea a su nombre.'
                : 'Hoy todos editan todo (Diego todavía no decide restringirlo).'}
            </span>
          </p>
          <p className="nota-suave">
            Se cambia en el .env del servidor: EXTERNO_SOLO_LO_SUYO=si o no.{config.politica_acceso === undefined ? ' Este servidor todavía no la publica: se toma apagada.' : ''}
          </p>
        </div>
      </Seccion>
      <Seccion titulo="Generador de PDF">
        <div className="hoja pila">
          <p className="estado-ia">
            <Chip tono={config.pdf.disponible ? 'verde' : 'rojo'}>{config.pdf.disponible ? 'Disponible' : 'No disponible'}</Chip>
            <span>{config.pdf.motivo ?? 'La plantilla de la familia de formatos responde.'}</span>
          </p>
          <p className="nota-suave">Formatos registrados hoy: {config.pdf.formatos.length ? config.pdf.formatos.join(', ') : 'ninguno'}. Los demás fallan hasta que la familia los publique.</p>
          {variantes && (
            <p className="nota-suave">
              Variantes construidas: {variantes.length ? variantes.map((v) => v.replace(/_/g, ' ')).join(', ') : 'ninguna'}
              {VARIANTES.some((v) => !variantes.includes(v)) ? ` · todavía no: ${VARIANTES.filter((v) => !variantes.includes(v)).map((v) => v.replace(/_/g, ' ')).join(', ')}` : ''}.
            </p>
          )}
        </div>
      </Seccion>
      <Seccion titulo="CRM de la plataforma (Carlos)">
        <div className="hoja pila">
          <p className="estado-ia">
            <Chip tono={config.crm_externo.activo ? 'verde' : 'neutro'}>{config.crm_externo.activo ? 'Conectado' : 'Apagado'}</Chip>
            <span>{config.crm_externo.motivo}</span>
          </p>
          {config.crm_externo.cola && (
            <p className="estado-ia" role={config.crm_externo.cola.fallidos ? 'alert' : undefined}>
              <Chip tono={config.crm_externo.cola.fallidos ? 'rojo' : config.crm_externo.cola.pendientes ? 'ambar' : 'verde'}>
                {config.crm_externo.cola.fallidos ? `${plural(config.crm_externo.cola.fallidos, 'envío falló', 'envíos fallaron')}` : config.crm_externo.cola.pendientes ? 'En cola' : 'Al día'}
              </Chip>
              <span>
                {config.crm_externo.cola.pendientes
                  ? `${plural(config.crm_externo.cola.pendientes, 'envío espera', 'envíos esperan')} su reintento (se mandan solos).`
                  : 'No hay envíos esperando.'}
                {config.crm_externo.cola.fallidos ? ' Los que fallaron ya no se reintentan: ábrelos en su cotización y vuelve a mandarlos, o avísale a Carlos.' : ''}
              </span>
            </p>
          )}
          <p className="nota-suave">El cotizador nunca toca el código ni la base de Carlos: cuando él acepte, solo le manda cada cotización a un punto que él publique.</p>
        </div>
      </Seccion>
      <Seccion titulo="Dónde se guarda">
        <div className="hoja">
          <p className="nota-suave">
            Base: {config.almacenamiento.efimero ? 'memoria del servidor de ENSAYO (se borra al apagarse)' : config.almacenamiento.base === 'local' ? 'esta Mac (SQLite)' : 'Datastore (nube)'} · archivos:{' '}
            {config.almacenamiento.efimero ? 'memoria del ensayo' : config.almacenamiento.archivos === 'local' ? 'esta Mac' : 'nube'} · versión {config.version_app}
          </p>
        </div>
      </Seccion>
    </div>
  );
}
